import React, { useState } from 'react';
import {
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Snackbar,
  CircularProgress,
  Alert
} from '@mui/material';

import SendIcon from '@mui/icons-material/Send';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

import { db } from "../firebase/firebase-config";
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

const Feedback = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [emailError, setEmailError] = useState(false);
  const [feedbackError, setFeedbackError] = useState(false);

  const validateForm = () => {
    let isValid = true;
    
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError(true);
      isValid = false;
    }

    // Feedback validation
    if (feedback.trim().length < 10) {
      setFeedbackError(true);
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      await addDoc(collection(db, 'feedback'), {
        email: email.trim(),
        feedback: feedback.trim(),
        timestamp: serverTimestamp()
      });
      setSnackbarMessage('Feedback submitted successfully!');
      setSnackbarSeverity('success');
      handleClose();
    } catch (error) {
      setSnackbarMessage('Failed to submit feedback. Please try again.');
      setSnackbarSeverity('error');
    } finally {
      setLoading(false);
      setSnackbarOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEmail('');
    setFeedback('');
    setEmailError(false);
    setFeedbackError(false);
  };

  return (
    <>
      <Fab
        color="primary"
        aria-label="feedback"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32
        }}
        onClick={() => setOpen(true)}
      >
        <ChatBubbleOutlineIcon />
      </Fab>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Send Feedback</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Email Address"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(false);
            }}
            error={emailError}
            helperText={emailError && 'Please enter a valid email address'}
            disabled={loading}
          />
          <TextField
            margin="dense"
            label="Feedback"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={feedback}
            onChange={(e) => {
              setFeedback(e.target.value);
              setFeedbackError(false);
            }}
            error={feedbackError}
            helperText={feedbackError && 'Feedback must be at least 10 characters'}
            disabled={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
          >
            Send Feedback
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Feedback;